export default __webpack_public_path__ + "static/video-f865d4ca17e22bcee87717d01b9b21eb.png";